/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import { queryOptions, useQuery } from "@tanstack/react-query"

import fetch from "~/backend/axiosClient"
import type {
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"

import type {
  FindAllProductPageComponentsQueryResponse,
  FindAllProductPageComponentsQueryParams,
} from "../types/FindAllProductPageComponents.ts"

export const findAllProductPageComponentsQueryKey = (
  params: FindAllProductPageComponentsQueryParams
) =>
  [{ url: "/v1/product-page-components" }, ...(params ? [params] : [])] as const

export type FindAllProductPageComponentsQueryKey = ReturnType<
  typeof findAllProductPageComponentsQueryKey
>

/**
 * @summary Find all product page components
 * {@link /v1/product-page-components}
 */
export async function findAllProductPageComponents(
  params: FindAllProductPageComponentsQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    FindAllProductPageComponentsQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "GET",
    url: `/v1/product-page-components`,
    params,
    ...requestConfig,
  })
  return res
}

export function findAllProductPageComponentsQueryOptions(
  params: FindAllProductPageComponentsQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const queryKey = findAllProductPageComponentsQueryKey(params)
  return queryOptions<
    ResponseConfig<FindAllProductPageComponentsQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<FindAllProductPageComponentsQueryResponse>,
    typeof queryKey
  >({
    enabled: !!params,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal
      return findAllProductPageComponents(params, config)
    },
  })
}

/**
 * @summary Find all product page components
 * {@link /v1/product-page-components}
 */
export function useFindAllProductPageComponents<
  TData = ResponseConfig<FindAllProductPageComponentsQueryResponse>,
  TQueryData = ResponseConfig<FindAllProductPageComponentsQueryResponse>,
  TQueryKey extends QueryKey = FindAllProductPageComponentsQueryKey,
>(
  params: FindAllProductPageComponentsQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<FindAllProductPageComponentsQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: typeof fetch }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...queryOptions } = queryConfig
  const queryKey =
    queryOptions?.queryKey ?? findAllProductPageComponentsQueryKey(params)

  const query = useQuery(
    {
      ...findAllProductPageComponentsQueryOptions(params, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
